module.exports = "/images/vendor/flag-icon-css/flags/4x3/nc.svg?b8c9f5e4fa65dc17c5f07773616fa3cb";